import type { ReactNode } from 'react';

export interface FilterFieldProps {
  /** Label text (e.g. "Game", "Server"). When set, renders a label above the control. */
  label?: string;
  /** id of the control; used for htmlFor when label is set. */
  id?: string;
  children: ReactNode;
  className?: string;
}

const labelClassName = 'block text-sm font-medium text-foreground mb-1';

export function FilterField({
  label,
  id,
  children,
  className = '',
}: Readonly<FilterFieldProps>) {
  if (!label) {
    return <>{children}</>;
  }
  return (
    <div className={className}>
      <label className={labelClassName} htmlFor={id}>
        {label}
      </label>
      {children}
    </div>
  );
}
